import React from 'react';
import { usePerformanceMonitor } from '../../utils/performanceMonitor';

interface BundleDebugInfoProps {
  enabled?: boolean;
}

export const BundleDebugInfo: React.FC<BundleDebugInfoProps> = ({ enabled = false }) => {
  usePerformanceMonitor(enabled);
  const [bundleInfo, setBundleInfo] = React.useState<{
    chunks: number;
    totalSize: number;
    loadTime: number;
  }>({ chunks: 0, totalSize: 0, loadTime: 0 });

  React.useEffect(() => {
    if (!enabled) return;

    const updateBundleInfo = () => {
      const jsResources = performance.getEntriesByType('resource')
        .filter(r => r.name.includes('.js'));
      
      const totalSize = jsResources.reduce((sum, r) => {
        const resourceEntry = r as PerformanceResourceTiming;
        return sum + (resourceEntry.transferSize || 0);
      }, 0);
      
      const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
      const loadTime = navigation.loadEventEnd - navigation.fetchStart;

      setBundleInfo({
        chunks: jsResources.length,
        totalSize: Math.round(totalSize / 1024),
        loadTime: Math.round(loadTime)
      });
    };

    // Update immediately and on load
    updateBundleInfo();
    window.addEventListener('load', updateBundleInfo);

    return () => window.removeEventListener('load', updateBundleInfo);
  }, [enabled]);

  if (!enabled) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 10,
      right: 10,
      background: 'rgba(0,0,0,0.9)',
      color: 'white',
      padding: '12px',
      borderRadius: '6px',
      fontSize: '11px',
      zIndex: 10000,
      fontFamily: 'monospace',
      minWidth: '200px',
      border: '1px solid #333'
    }}>
      <div style={{ fontWeight: 'bold', marginBottom: '8px', color: '#00ff88' }}>
        🔍 Bundle Debug Monitor
      </div>
      <div>📦 Chunks loaded: <span style={{ color: '#ffaa00' }}>{bundleInfo.chunks}</span></div>
      <div>📊 Total JS size: <span style={{ color: '#ffaa00' }}>{bundleInfo.totalSize}KB</span></div>
      <div>⚡ Load time: <span style={{ color: '#ffaa00' }}>{bundleInfo.loadTime}ms</span></div>
      <div style={{ marginTop: '8px', fontSize: '10px', color: '#ccc' }}>
        Check console for detailed logs
      </div>
    </div>
  );
};